import { environment } from "src/environments/environment";

export const onlineApiUrlBase = environment.apiUrl;
export const testApiUrlBase = environment.apiTestUrl;

export const apiUrlBase = onlineApiUrlBase;

const apiEndpoints = {
  apiUrlBase: apiUrlBase,
  signinUrl: `${apiUrlBase}/auth/login/`,
  signupUrl: `${apiUrlBase}/auth/signup/`,
  registerUrl: `${apiUrlBase}/auth/users/`,
  signoutUrl: `${apiUrlBase}/auth/signout/`,
  forgotPasswordUrl: `${apiUrlBase}/auth/reset-password/`,
  resetPasswordUrl: `${apiUrlBase}/auth/reset-password-confirm/`,
  firstResetPasswordUrl: `${apiUrlBase}/auth/first-login/change-password/`,
  changePasswordUrl: `${apiUrlBase}/auth/set-password/`,
  verifyEmailUrl: `${apiUrlBase}/auth/users/activation/`,
  resendVerificationUrl: `${apiUrlBase}/auth/activation/resend/`,
  logoutUrl: `${apiUrlBase}/auth/logout/`,
  uploadProfileUrl: `${apiUrlBase}/users/profile/image/`,
  usersUrl: `${apiUrlBase}/auth/users/`,
  authUrl: `${apiUrlBase}/auth/`,
  configsSiteUrl: `${apiUrlBase}/configs-site/`,
  newsUrl: `${apiUrlBase}/news/`,
  testimonialsUrl: `${apiUrlBase}/testimonials/`,
  quotesUrl: `${apiUrlBase}/quotes/`,
  trainingsCategoriesUrl: `${apiUrlBase}/trainings-categories/`,
  trainingsUrl: `${apiUrlBase}/trainings/`,
  newslettersUrl: `${apiUrlBase}/user-newsletters/`,
  paymentsUrl: `${apiUrlBase}/payments/`,
  contactsUrl: `${apiUrlBase}/contacts/`,
  commentsUrl: `${apiUrlBase}/comments/`,
  signalsUrl: `${apiUrlBase}/signals/`,
  resourcesCategoriesUrl: `${apiUrlBase}/resources-categories/`,
  resourcesUrl: `${apiUrlBase}/resources/`,
  signalsCategoriesUrl: `${apiUrlBase}/signals-categories/`,
  coachingsUrl: `${apiUrlBase}/coachings/`,
  coachingsCategoriesUrl: `${apiUrlBase}/coachings-categories/`,
  faqsUrl: `${apiUrlBase}/faqs/`,
  userTrainingsUrl: `${apiUrlBase}/user-trainings/`,
  adminUrl: `${apiUrlBase}/admin/`,
  userUrl: `${apiUrlBase}/user/`,
  referralsUrl: `${apiUrlBase}/referrals/`,
  cryptoPurchasesUrl: `${apiUrlBase}/crypto-purchases/`,
  webinarsUrl: `${apiUrlBase}/webinars/`,
}

export default apiEndpoints;
